<div
  class="notification-item"
  [class.unread]="!notification.read"
  role="button"
  tabindex="0"
  (click)="open.emit(notification)"
  (keydown.enter)="open.emit(notification)">
  <mat-icon class="notification-item-icon">{{ icon }}</mat-icon>
  <div class="notification-item-body">
    <span class="notification-item-title">{{ notification.title }}</span>
    <span class="notification-item-message">{{ notification.message }}</span>
    <span class="notification-item-time">{{ notification.date | date: 'dd/MM/yyyy, HH:mm' }}</span>
  </div>
  <span class="notification-unread-dot" *ngIf="!notification.read"></span>
</div>
